<template>
  <v-carousel cycle height="540" hide-delimiter-background show-arrows-on-hover>
    <v-carousel-item v-for="(link, i) in linkList" :key="i">
      <v-sheet :color="colors[i]"  height="100%">
        <v-row align="center" justify="center" class="fill-height">
          <div align="center" class="dateline">In {{link.dateline}} Today:</div>
          <div align="center"  class="display-2 link-name">{{ link.name }}</div><br>
          <div align="center" class="description" >{{link.description}}</div><br>
          <div align="center" class="tags">Tags: <span class="tag"> {{link.tags}}</span></div><br>
          <v-btn large color="primary" :href="link.url" class="read-more">Read More 
            <v-icon right dark>mdi-chevron-right-circle</v-icon>
          </v-btn>  
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>

  import db from '@/firebase/init'

  export default {

    data () {
      return {
        linkList: [],
        colors: [
            'blue lighten-1',
            'green lighten-1',
            'pink darken-1',
            'purple darken-2',
            'purple darken-2',
            'light-green darken-1',
            'deep-orange darken-1',
            'red accent-3',
            'indigo',
          ], 
      }
    },

    mounted(){
        db.collection('uri').orderBy("date_time", "desc").limit(9).get()
          .then(snapshot => {
              snapshot.docs.forEach(doc => {

                let tags =   doc.data().tags 
                let tagList = tags.join(" . ");

                  var linksObj = {
                    'name' : doc.data().name,
                    'description': doc.data().desc,
                    'url' : doc.data().url,
                    'slug':doc.data().slug,
                    'pol' :doc.data().pol,
                    'clicks' : doc.data().clicks,
                    'cat' : doc.data().category,
                    'tags' : tagList,
                    'dateline': doc.data().dateline
                  }
          
                  this.linkList.push(linksObj)
              })
          })  
    }
  }

</script>

<style scoped>
.dateline{width:100%; text-align: center; padding:10px 0 0 0; line-height:1; text-transform:uppercase;}
.link-name {width:100%; text-align: center; margin:0 .5em 0 .5em; line-height:1;}
.description{ width:100%; text-align: center; font-size:1.2em; padding:0 10px 0 10px;  line-height:1.1;}
.tags{ width:100%; text-align: center; font-size:1; padding:0 10px 0 10px;  line-height:1.1;}
.read-more{margin-bottom:2.5em;}
.tag{color:#F0F4C3;}
</style>